const toString = value => (typeof value === 'string' ? value : JSON.stringify(value));

const toURIParams = obj =>
  Object.entries(obj)
    .reduce(
      (ret, [key, value]) =>
        typeof value !== 'undefined'
          ? [...ret, `${key}=${encodeURIComponent(toString(value))}`]
          : ret,
      [],
    )
    .join('&');

export default toURIParams;
